import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material';

export const menuItem: {
  defaultProps?: ComponentsProps['MuiMenuItem'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiMenuItem'];
  variants?: ComponentsVariants<Theme>['MuiMenuItem'];
} = {
  styleOverrides: {
    root({ theme }) {
      return {
        borderRadius: theme.shape.borderRadius,
        // Une entrée de menu de 32px se rate au pouce. 44px est le minimum
        // recommandé, et ne coûte rien à un menu qui défile.
        [theme.breakpoints.down('md')]: {
          minHeight: 44
        }
      };
    }
  }
};
